import TopCategoriesWidgetView from './TopCategoriesWidgetView.vue';

export const type = 'topCategories';
export const view = TopCategoriesWidgetView;

export function builder() {
  return {
    type,
    top: 0,
    rotate: 0,
    zIndex: 1,
    cardWidth: 90,
    gap: 10,
    textColor: '#205441',
    fontFamily: 'SimplerPro',
    fontSize: 18,
    categoriesAmount: 5,
    boxShadow: '0px 16px 46px rgba(22.80, 123.92, 42.57, 0.62)',
    variableName: '',
    variableData: [
      {
        categoryLabel: 'Bills',
        averageSpending: 650,
      },
      {
        categoryLabel: 'Groceries',
        averageSpending: 420,
      },
      {
        categoryLabel: 'Transport',
        averageSpending: 320,
      },
      {
        categoryLabel: 'Entertainment',
        averageSpending: 250,
      },
      {
        categoryLabel: 'Dining Out',
        averageSpending: 180,
      },
    ],
  };
}
